module.exports = __webpack_public_path__ + "static/media/local_parking.09559a46.svg";